import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { reactHtmlParser } from '../../../../common/common';

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {
  title: PropTypes.string.isRequired,
  isLive: PropTypes.string.isRequired
};

const defaultProps = {
  title: '',
  isLive: false
};
/**
 *
 */
const Title = ({ title = '', isLive = false }) => {
  return (
    <>
      {isLive && <span className="clr_player__liveTag active">Live</span>}
      {title && (
        <h1 className="clr_player__header--ttl" title={title}>
          {reactHtmlParser(title)}
        </h1>
      )}
    </>
  );
};

// Title.propTypes = propTypes;
// Title.defaultProps = defaultProps;
// #endregion

export default memo(Title);
